import ApiService from './api.service';
import IBox from "../models/box";

export async function startCollectProcessAndHandle(props: any): Promise<boolean> {
    const startCollectResult = await ApiService.startCollectProcess();

    if (!startCollectResult || startCollectResult.errorCode) {
        return false;
    }

    ApiService.isProcessStarted = true;

    props.setAgeControlType(startCollectResult.ageControlType);

    const hasAgeControlled = startCollectResult.ageControlType > 0;
    const noAgeControlledBoxes = props.boxes.every((box: IBox) => !box.isAgeControlled);

    if (!props.order.ageConfirmed &&
        hasAgeControlled &&
        props.order.awarenessEnabled &&
        ((props.order.hasAgeRestrictions && noAgeControlledBoxes) || props.order.awarenessForceEnabled)) {
        props.setAllBoxesAgeControlled(true);
    }

    if (startCollectResult.attendantNotified) {
        props.setIsNotificationSented(startCollectResult.attendantNotified);
    }
    return true;
}